import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import { EntityTypes } from '../../../../../new-lib/constants/common';
import router, { useRouter } from 'next/router';
import CTA from '../../../../../new-components/ui/CTA';
import { SearchFiltersTypes } from '../../../../../reducers/search-filters/reducer';
import { useSelector } from 'react-redux';
import { ExtraContactParams } from '../../../../../new-lib/analytics';

interface ChildProps {
  entity: any;
  entityType: EntityTypes;
  contactEventExtraParams?: ExtraContactParams;
}

const LowerDetails = ({
  entity,
  entityType,
  contactEventExtraParams
}: ChildProps) => {
  const { t } = useTranslation(['entity', 'common']);
  const { asPath } = useRouter();
  const webview = useSelector((state: any) => state.app.webview);
  const propertyNavigator = () => {
    router.push({
      pathname: `/search`,
      query: {
        [SearchFiltersTypes.PROPERTY_TYPES]: entity.property_type.id,
        [SearchFiltersTypes.BEDROOMS]: entity.number_of_bedrooms,
        [SearchFiltersTypes.MIN_PRICE]: entity.min_price
      }
    });
  };

  return (
    <MStickyLower id="lower-details">
      {!entity.on_sale && entityType == EntityTypes.PROPERTY ? (
        <div className="off-sale">
          <SoldOutBtn>{t('sold_out')}</SoldOutBtn>
          <button className="check-property" onClick={propertyNavigator}>
            {t('check_same_property')}
          </button>
        </div>
      ) : (
        <>
          {asPath.includes('nawy-now') && (
            <div className="cta-text">
              <span>{t('nawy_now_cta')}</span>
            </div>
          )}
          {webview !== 'partners' && (
            <div className="action-btns">
              <CTA
                entity={entity}
                entityType={entityType}
                eventExtraParams={contactEventExtraParams}
              />
            </div>
          )}
        </>
      )}
    </MStickyLower>
  );
};

const MStickyLower = styled.div<any>`
  height: auto;
  width: 100vw;
  position: fixed;
  padding: 16px;
  bottom: 0;
  left: 0;
  background: #f8f8f8;
  box-shadow: 0px -5px 25px rgba(0, 0, 0, 0.15);
  border-radius: 8px 8px 0px 0px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  .check-property {
    width: 100%;
    padding: 5px 16px;
    background: ${props => props.theme.light.colors.whitish};
    border-radius: 8px;
    border: none;
    margin-top: 12px;
    font-size: ${props => props.theme.font.sizes.s};
    color: ${props => props.theme.light.colors.primaryBlue};
    font-family: materialMedium;
  }

  .cta-text {
    align-self: flex-start;
    font-family: materialBold;
    font-size: 20px;
  }
  .action-btns {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: space-evenly;
    width: 100%;
    button {
      min-width: 160px;
    }
  }
`;
const SoldOutBtn = styled.span`
  width: auto;
  padding: 2.5px 16px;
  background: #c1272d;
  border-radius: 8px;
  font-size: ${props => props.theme.font.sizes.s};
  color: ${props => props.theme.light.colors.white};
  text-align: center;
`;
export default LowerDetails;
